import { useFormik } from "formik";
import React, { useEffect, useState, useRef } from "react";
import ErrorText from "../common/ErrorText";
import * as Yup from "yup";
import apiCall from "../../helpers/apifactory";
import CloseIcon from "@mui/icons-material/Close";
import styles from "../../Styles/modal.module.css";
import ReCAPTCHA from "react-google-recaptcha";
import MobileFaqs from "./MobileFaqs";
// import DatePicker from "react-date-picker";
import DatePicker from "react-datepicker";
import LaptopFaqs from "./LaptopFaqs";

const CustomerService = () => {
  useEffect(() => {
    let current_page = window.location.href.split("/").at(-1);
    setTimeout(() => {
      document
        .getElementById(`${current_page}`)
        ?.scrollIntoView({ marginTop: "300px", behavior: "smooth" });
    }, 100);
  });
  window.addEventListener(
    "scroll",
    function (event) {
      let top = this.scrollY,
        window_width = window.innerWidth,
        header_height = document.querySelector("header").style.height + 100;
      // (top > header_height && window_width > 1024) ? document.querySelector("nav").classList.add('fixed-header-desktop') : document.querySelector("nav").classList.remove('fixed-header-desktop')
      top > header_height && window_width > 1024
        ? document.querySelector("a").classList.add("fixed-header-desktop")
        : document.querySelector("a").classList.remove("fixed-header-desktop");
    },
    false,
  );
  window.addEventListener(
    "scroll",
    function (event) {
      let top = this.scrollY,
        window_width = window.innerWidth,
        header_height = document.querySelector("header").style.height + 100;
      top > header_height && window_width > 1024
        ? document.querySelector("nav").classList.add("fixed-header-desktop")
        : document
            .querySelector("nav")
            .classList.remove("fixed-header-desktop");
      // (top > header_height && window_width > 1024) ? document.querySelector("a").classList.add('fixed-header-desktop') : document.querySelector("a").classList.remove('fixed-header-desktop')
    },
    false,
  );
  const inputRef = useRef(null);

  const [show, setShow] = useState(false);
  const modalRef = useRef(null);

  useEffect(() => {
    if (show) {
      modalRef.current.classList.add(styles.visible);
    } else {
      modalRef.current.classList.remove(styles.visible);
    }
  }, [show]);

  const formik = useFormik({
    initialValues: {
      name: "",
      email: "",
      consNum: "",
      date: "",
      num: "",
      mes: "",
      type: "",
      att: {},
      recaptcha: "",
    },
    validationSchema: Yup.object({
      name: Yup.string().required("This is Required"),
      email: Yup.string()
        .email("Invalid email address")
        .required("This is Required"),
      consNum: Yup.string()
        .max(12, "Maximum 12 digits allowed")
        .required("This is Required"),
      date: Yup.string().required("This is Required"),
      num: Yup.string()
        .matches(/^((\+92)?(0092)?(92)?(0)?)(3)([0-9]{9})$/gm, {
          message: "Invalid phone number",
          excludeEmptyString: false,
        })
        .required("This is Required"),
      mes: Yup.string().required("This is Required"),
      type: Yup.string().required("This is Required"),
      att: Yup.object(),
      recaptcha: Yup.string().required(),
    }),
    onSubmit: (values) => {
      const body = {
        toEmailID: "customerservices@tcs.com.pk",
        // toEmailID: "farhan.ahmed@tcs.com.pk",
        emailSubject: "Customer Service",
        cc: values?.email,
        bcc: values?.email,
        attachments: [values?.att],
        consNum: values?.consNum,
        num: values?.num,
        emailText: `
        name: ${values?.name} <br />
        email: ${values?.email} <br />
        consignment Number: ${values?.consNum} <br />
        date: ${values?.date} <br />
        contact: ${values?.num} <br />
        type: ${values?.type} <br />
        message: ${values?.mes} <br />
        replyTo: ${values?.custEmail},
        `,
      };

      apiCall
        .sendEmail(body, {})
        .then((res) => {
          setShow(true);
          formik.setValues(formik?.initialValues);
          formik.setTouched({}, false);
        })
        .catch((error) => {
          console.log(error);
        });
    },
  });

  const handleFileRead = async (event) => {
    const file = event.target.files[0];
    await convertBase64(file, event);
  };

  const convertBase64 = (file, e) => {
    return new Promise((resolve, reject) => {
      const fileReader = new FileReader();
      fileReader.readAsDataURL(file);
      fileReader.onload = () => {
        resolve(fileReader.result);
        formik?.setFieldValue("att", {
          fileName: e?.target?.files[0]?.name,
          contentType: "application/octet-stream", //contentType: e?.target?.files[0]?.type,
          base64File: fileReader?.result?.split(",")[1],
        });
      };
      fileReader.onerror = (error) => {
        reject(error);
      };
    });
  };

  const scrollToFirstError = (errors) => {
    if (!errors || Object.keys(errors).length === 0) return;

    // Saare error wale elements DOM se nikaalo
    const errorFields = Object.keys(errors)
      .map((fieldName) => document.querySelector(`[name="${fieldName}"]`))
      .filter(Boolean);

    if (errorFields.length > 0) {
      // DOM position ke hisaab se sabse pehla element choose karo
      const firstErrorElement = errorFields.reduce((closest, el) => {
        return !closest ||
          el.getBoundingClientRect().top < closest.getBoundingClientRect().top
          ? el
          : closest;
      }, null);

      if (firstErrorElement) {
        firstErrorElement.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
        firstErrorElement.focus({ preventScroll: true });
      }
    }
  };

  return (
    <div>
      <div className="contactus-image">
        <img src="/new-image/contact-us.jpg" alt="" className="w-[100%]" />
      </div>
      <div className="bg-[#efefef] flex flex-col justify-center items-center min-h-[190px] py-[4rem]">
        <p className="text-[1.05rem] mt-[-5px] max-w-[45rem] m-[auto] text-center mx-[1rem]">
          As an organisation that directly interacts with its customers on a
          daily basis, we believe in finding ways to constantly improve our
          services by understanding your needs better. Our call centre, highly
          motivated social media teams and WhatsApp response systems are all
          ears. Please do not hesitate to contact us with your queries, input,
          or feedback.
        </p>
      </div>
      <div className="my-[3rem] flex gap-4 items-center justify-center text-center flex-wrap">
        {/* <div className="bg-[#fbfbfb] flex flex-col gap-2 justify-center items-center w-[25rem] h-[15rem] p-4">
          <img src="/social/whatsappGreen.png" alt="" className="w-[5rem]" />
          <h2 className="font-bold text-xl">Chat with us on WhatsApp</h2>

          <a
            href="https://wa.me/9221111123456"
            target="_blank"
            className="font-semibold text-[#F21E26]"
          >
            +92 21 111 123 456
          </a>
        </div> */}
        <div className="bg-[#fbfbfb] flex flex-col gap-2 justify-center items-center w-[25rem] h-[15rem] p-4 ">
          <img src="/social/socialMix.png" alt="" className="w-[5rem]" />
          <h2 className="font-bold text-xl">Social Media Links</h2>
          <div className="flex gap-6">
            <div className="flex gap-4">
              <a target="_blank" href="https://www.facebook.com/tcscouriers/">
                <img src="/social/fb.svg" alt="" className="h-5 social_f" />
              </a>
              <a target="_blank" href="https://wa.me/9221111123456">
                <img
                  src="/social/whatsapp.svg"
                  alt=""
                  className="h-5 social_w"
                />
              </a>
              <a target="_blank" href="https://www.instagram.com/tcs_couriers/">
                <img
                  src="/social/instagram.svg"
                  alt=""
                  className="h-5 social_i"
                />
              </a>
              <a target="_blank" href="https://twitter.com/tcs_couriers">
                <img
                  src="/social/twitter.svg"
                  alt=""
                  className="h-5 social_t"
                />
              </a>
              <a
                target="_blank"
                href="https://www.youtube.com/channel/UCrniUiy5dGDEZ1f4jieAS3Q"
              >
                <img
                  src="/social/youtube.svg"
                  alt=""
                  className="h-5 social_y"
                />
              </a>
              <a
                target="_blank"
                href="https://www.linkedin.com/company/tcs-private-limited/?originalSubdomain=pk"
              >
                <img
                  src="social/linkedin.svg"
                  alt=""
                  className="h-[1.2rem] social_l"
                />
              </a>
            </div>
          </div>
        </div>
      </div>
      <div className="flex flex-col justify-center items-center mt-[3rem] mb-[2rem] mx-[4rem] sm:mx-[2rem] ">
        <h1 className="font-bold text-3xl sm:text-4xl mb-[3rem] ">
          Contact Us Form
        </h1>
        <div className="flex flex-col gap-3 sm:p-8 text-sm md:w-[45rem] sm:w-[40rem] w-[auto]  mx-[1rem] rounded-md transition-all duration-500">
          <div className="sm:flex grid gap-4">
            <div className="MuiFormControl-root MuiTextField-root flex-1">
              <div className="">
                <div className="relative">
                  <input
                    type="text"
                    id="name"
                    className="block px-2.5 pb-2 pt-2 w-full text-sm text-light bg-transparent rounded border border-gray focus:border-red hover:border-black focus:outline-none focus:ring-0 focus:border-red-600 peer"
                    placeholder=" "
                    name="name"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.name}
                  />
                  <label
                    htmlFor="name"
                    className="absolute text-xs text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white bg-gray px-2 peer-focus:px-2 peer-focus:text-red-600 peer-focus:dark:text-red-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1"
                  >
                    Your Name*
                  </label>
                </div>
                <ErrorText
                  text={formik?.touched?.name && formik?.errors?.name}
                />
              </div>
              <div className="">
                <div className="relative mt-1">
                  <input
                    type="number"
                    id="consNum"
                    className="block px-2.5 pb-2 pt-2 w-full text-sm text-light bg-transparent rounded border border-gray focus:border-red hover:border-black focus:outline-none focus:ring-0 focus:border-red-600 peer"
                    placeholder=" "
                    name="consNum"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.consNum}
                    min={0}
                    maxLength={12}
                  />
                  <label
                    htmlFor="consNum"
                    className="absolute text-xs text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white bg-gray px-2 peer-focus:px-2 peer-focus:text-red-600 peer-focus:dark:text-red-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1"
                  >
                    Consignment #*
                  </label>
                </div>
                <ErrorText
                  text={formik?.touched?.consNum && formik?.errors?.consNum}
                />
              </div>
            </div>
            <div className="MuiFormControl-root MuiTextField-root flex-1">
              <div className="">
                <div className="relative">
                  <input
                    type="text"
                    id="email"
                    className="block px-2.5 pb-2 pt-2 w-full text-sm text-light bg-transparent rounded border border-gray focus:border-red hover:border-black focus:outline-none focus:ring-0 focus:border-red-600 peer"
                    placeholder=" "
                    name="email"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.email}
                  />
                  <label
                    htmlFor="email"
                    className="absolute text-xs text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white bg-gray px-2 peer-focus:px-2 peer-focus:text-red-600 peer-focus:dark:text-red-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1"
                  >
                    Your Email*
                  </label>
                </div>
                <ErrorText
                  text={formik?.touched?.email && formik?.errors?.email}
                />
              </div>
              <div className="">
                <div className="relative mt-1 grid">
                  <DatePicker
                    className="calendar block px-2.5 h-[2.4rem] w-full text-sm text-light bg-transparent rounded border border-gray-500 focus:border-red hover:border-black"
                    id="date"
                    name="date"
                    onChange={(e) => formik?.setFieldValue("date", e)}
                    onBlur={formik.handleBlur}
                    value={formik.values.date}
                    selected={formik.values.date} // Use Formik value for selection
                    minDate={new Date()}
                    placeholderText="--/--/----"
                  />

                  <label
                    htmlFor="date"
                    className="absolute text-xs text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white bg-gray px-2 peer-focus:px-2 peer-focus:text-red-600 peer-focus:dark:text-red-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1"
                  >
                    Date
                  </label>
                </div>
                <ErrorText
                  text={formik?.touched?.date && formik?.errors?.date}
                />
              </div>
            </div>
          </div>
          <div className="sm:flex grid gap-4">
            <div className="MuiFormControl-root MuiTextField-root flex-1">
              <div className="">
                <div className="relative">
                  <input
                    type="text"
                    id="num"
                    className="block px-2.5 pb-2 pt-2 w-full text-sm text-light bg-transparent rounded border border-gray focus:border-red hover:border-black focus:outline-none focus:ring-0 focus:border-red-600 peer"
                    placeholder=" "
                    name="num"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.num}
                  />
                  <label
                    htmlFor="num"
                    className="absolute text-xs text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white bg-gray px-2 peer-focus:px-2 peer-focus:text-red-600 peer-focus:dark:text-red-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1"
                  >
                    Your Contact Number*
                  </label>
                </div>
                <ErrorText text={formik?.touched?.num && formik?.errors?.num} />
              </div>
            </div>
            <div className="MuiFormControl-root MuiTextField-root flex-1">
              <div className="">
                <div className="relative ">
                  <select
                    id="type"
                    className="block px-2.5 pb-2 pt-2 w-full text-sm text-light bg-transparent rounded border border-gray focus:border-red hover:border-black focus:outline-none focus:ring-0 focus:border-red-600 peer"
                    placeholder=""
                    name="type"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.type}
                  >
                    <option>Please Select</option>
                    <option>Complaint</option>
                    <option>Track</option>
                    <option>Request & General Feedback</option>
                  </select>

                  <label
                    htmlFor="type"
                    className="absolute text-xs text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white bg-gray px-2 peer-focus:px-2 peer-focus:text-red-600 peer-focus:dark:text-red-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1"
                  >
                    Type
                  </label>
                </div>
                <ErrorText
                  text={formik?.touched?.type && formik?.errors?.type}
                />
              </div>
            </div>
          </div>
          <div className="">
            <div className="attachment relative  text-black  rounded-md  p-[.2rem] mt-1 border-2 border-black-10">
              <div className="flex justify-between p-.5 border-black-500">
                <p className="relative  text-[grey] text-sm rounded-sm  p-[.2rem]">
                  {formik?.values?.att?.fileName
                    ? formik?.values?.att?.fileName
                    : "Attachment"}
                </p>

                <button onClick={(e) => inputRef.current.click(e)}>
                  <img src="/Home/paperclip.svg" className="-rotate-45" />
                </button>
              </div>
              <input
                id="fileUpload"
                type="file"
                multiple
                style={{ display: "none" }}
                accept="application/pdf, image/png"
                onChange={handleFileRead}
                name="att"
                onBlur={formik.handleBlur}
                ref={inputRef}
              />
            </div>
            <ErrorText text={formik?.touched?.att && formik?.errors?.att} />
          </div>

          <div className="">
            <div className="relative">
              <textarea
                rows={7}
                cols={5}
                style={{
                  lineHeight: "1rem",
                  paddingTop: "20px",
                  paddingBottom: "10px",
                }}
                type="text"
                id="mes"
                className="block px-2.5 pb-2 pt-2 w-full text-sm text-light bg-transparent rounded border border-gray focus:border-red hover:border-black focus:outline-none focus:ring-0 focus:border-red-600 peer"
                placeholder=" "
                name="mes"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.mes}
              />
              <label
                htmlFor="mes"
                className="absolute text-xs text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-12 scale-75 top-2 z-10 origin-[0] bg-white bg-gray px-2 peer-focus:px-2 peer-focus:text-red-600 peer-focus:dark:text-red-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/0 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1"
                style={{ fontSize: "13px" }}
              >
                Your Message*
              </label>
            </div>

            <ErrorText text={formik?.touched?.mes && formik?.errors?.mes} />
          </div>
          {/*  */}
          <div className="flex flex-col justify-center items-center mb-[1rem] ">
            <div className="flex gap-4 md:w-[41rem] sm:w-[36rem] w-[18.5rem]">
              <div className="g-recaptcha">
                <ReCAPTCHA
                  sitekey={process.env.REACT_APP_CAPTCH}
                  onChange={(value) => {
                    formik.setFieldValue("recaptcha", value);
                  }}
                />
              </div>
            </div>
          </div>
          <button
            // onClick={(e) => {
            //   e.preventDefault();
            //   Promise.resolve(formik.validateForm()).then((errors) => {
            //     if (Object.keys(errors).length > 0) {
            //       scrollToFirstError(errors);
            //       formik.setTouched(
            //         Object.keys(errors).reduce(
            //           (t, key) => ({ ...t, [key]: true }),
            //           {}
            //         )
            //       );
            //     } else {
            //       formik.handleSubmit();
            //     }
            //   });
            // }}
            onClick={formik?.handleSubmit}
            type="submit"
            className="text-white bg-[#D40511] h-[2.5rem] border border-[#F21E26]  md:w-[41rem] sm:w-[36rem] w-[19rem]  rounded-md  p-1 text-sm hover:bg-[#F21E26] hover:text-white transition-all duration-500"
          >
            SUBMIT
          </button>
        </div>
      </div>

      <div id="laptop-faqs">
        <MobileFaqs />
      </div>
      <div id="laptop-faqs">
        <LaptopFaqs />
      </div>

      <div
        ref={modalRef}
        className={`${styles.modal__wrap}`}
        onClick={() => setShow(false)}
      >
        <div
          className={`flex flex-col justify-center items-center ${styles.modal}`}
        >
          <div className="bg-white h-[106%] relative z-[1000] rounded-3xl">
            <div className="flex justify-center items-center">
              <img
                src="/popup-circle.png"
                alt=""
                className="mx-auto w-[12.5rem]"
              />
              <img
                src="/popup-icon.png"
                alt=""
                className="absolute top-[-3.5rem] mx-auto w-[7rem]"
              />
            </div>
            <div className="absolute right-[1rem] top-[1rem] ">
              <CloseIcon fontSize="large" style={{ color: "#f21e26" }} />
            </div>
            <div className="flex flex-col text-center justify-center item-center mt-[6rem]">
              <h2 className="font-bold text-xl">Thank you for submitting.</h2>
              <p>We’ll contact you soon.</p>
            </div>
          </div>
          <div className="mx-auto bg-[#ed1d25] w-[80%] h-[2rem] rounded-full mt-[-1.2rem]"></div>
        </div>
      </div>
    </div>
  );
};

export default CustomerService;
